import "./wsFunctions/socket.js";
import { listenToMessages } from "./wsFunctions/socket.js";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styling/Layout.css';
import './styling/Components.css';
import App from './App';

listenToMessages((e) => {
    if (e.data.type === "refresh")
    window.location.reload();
});

// Render website
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
